import styled from "styled-components"
import { theme } from "Theme"

const Nav = styled.nav`
  width: 100%;
  color: ${theme.colors.black.base};
`

export default Nav
